/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type {
  TrustRelationshipGetResponse,
  TrustRelationshipUpdateRequest,
} from '@modules/cloud-api/v1/types'
import type { AsyncRequestState } from '@modules/ui-types'

import { resetUpdateTrustRelationship, updateTrustRelationship } from '@/actions/trustManagement'
import { updateTrustRelationshipRequest } from '@/reducers/asyncRequests/registry'

import TrustRelationshipFlyout from './TrustRelationshipFlyout'

import type { ThunkDispatch, ReduxState } from '@/types/redux'

type StateProps = {
  onSaveRequest: AsyncRequestState
}

type DispatchProps = {
  onSave: (payload: TrustRelationshipUpdateRequest) => Promise<unknown>
  resetOnClose: () => void
}

type ConsumerProps = {
  regionId: string
  trustRelationship: TrustRelationshipGetResponse
}

const mapStateToProps = (
  state: ReduxState,
  { regionId, trustRelationship: { id } }: ConsumerProps,
): StateProps => ({
  onSaveRequest: updateTrustRelationshipRequest(state, regionId, id),
})

const mapDispatchToProps = (
  dispatch: ThunkDispatch,
  { regionId, trustRelationship }: ConsumerProps,
): DispatchProps => ({
  onSave: (payload) =>
    dispatch(
      updateTrustRelationship({ regionId, payload, trustRelationshipId: trustRelationship.id }),
    ),
  resetOnClose: () => dispatch(resetUpdateTrustRelationship(regionId, trustRelationship.id)),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(TrustRelationshipFlyout)
